<template>
  <div class="mb-10">
    <v-form v-model="isFormValid">
      <div class="mb-8">
        <h1>児童アカウント 新規作成</h1>
      </div>

      <div class="my-8">
        <h4>園児区分*</h4>
        <v-select
          :rules="[required]"
          variant="outlined"
          density="compact"
          hide-details
          :items="childTypeOptions"
          item-title="label"
          item-value="value"
          v-model="childcareType"
          color="primary"
        ></v-select>
      </div>

      <div class="my-8">
        <h4 class="mb-2">氏名*</h4>
        <v-row>
          <v-col cols="6">
            <v-text-field
              variant="outlined"
              density="compact"
              hide-details
              label="姓"
              v-model="lastName"
              :rules="[required]"
              color="primary"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              variant="outlined"
              density="compact"
              hide-details
              label="名"
              v-model="firstName"
              :rules="[required]"
              color="primary"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              variant="outlined"
              density="compact"
              hide-details
              label="姓 (カタカナ)"
              v-model="lastNameKana"
              :rules="[required, isKatakana]"
              color="primary"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              variant="outlined"
              density="compact"
              hide-details
              label="名 (カタカナ)"
              v-model="firstNameKana"
              :rules="[required, isKatakana]"
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>

      <div class="my-8">
        <h4 class="mb-2">園で管理しているコード/番号 (自由記入)</h4>
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          label="任意コード1"
          v-model="optionalChildCode1"
          class="mb-2"
          color="primary"
        ></v-text-field>
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          label="任意コード2"
          v-model="optionalChildCode2"
          color="primary"
        ></v-text-field>
      </div>

      <div class="my-8">
        <h4 class="mb-2">生年月日*</h4>
        <v-text-field
          :rules="[required]"
          variant="outlined"
          density="compact"
          hide-details
          type="date"
          label="生年月日"
          v-model="dateOfBirth"
          color="primary"
        ></v-text-field>
      </div>

      <div class="my-8">
        <h4 class="mb-2">性別*</h4>
        <v-select
          :rules="[required]"
          variant="outlined"
          density="compact"
          hide-details
          :items="genderOptions"
          item-title="label"
          item-value="value"
          v-model="gender"
          color="primary"
        ></v-select>
      </div>

      <div class="my-8">
        <h4 class="mb-2">入園日 (予定)*</h4>
        <v-text-field
          :rules="[required]"
          variant="outlined"
          density="compact"
          hide-details
          type="date"
          label="入園日"
          v-model="admissionDate"
          color="primary"
        ></v-text-field>
      </div>

      <div class="my-8">
        <h4 class="mb-2">卒園日 (予定)</h4>
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          type="date"
          label="卒園日"
          v-model="graduationDate"
          color="primary"
        ></v-text-field>
      </div>

      <div class="my-8">
        <h4>延長保育パターン</h4>
        <v-select
          v-model="hoursPatternId"
          :items="patternList"
          item-title="patternTitle"
          item-value="patternId"
          variant="outlined"
          density="compact"
          hide-details
          color="primary"
        ></v-select>
      </div>

      <!-- <div class="my-8">
      <v-checkbox
        v-model="moveOrLeave"
        label="転園・卒園"
      ></v-checkbox>

      <div v-if="moveOrLeave">
        <v-textarea
          variant="outlined"
          density="compact"
          hide-details
          full-width
          label="理由"
          v-model="moveOrLeaveReason"
        ></v-textarea>
      </div>
    </div> -->

      <div>
        <v-progress-linear
          v-if="isCreating"
          indeterminate
          color="primary"
          class="my-8"
        ></v-progress-linear>
      </div>

      <div class="d-flex align-center">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          variant="flat"
          x-large
          @click="create"
          :disabled="isCreating || !isFormValid"
          >保存</v-btn
        >
        <v-spacer></v-spacer>
      </div>
    </v-form>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import { childAccountCreateModule } from "@/store/dataModules/childAccountCreateModule";
import LocalDataService from "@/service/LocalDataService";
import { classModule } from "@/store/dataModules/classModule";
import {
  NurseryClassResponse,
  NurseryHoursPatternResponse,
} from "chaild-api/lib";
import ValidationMixin from "@/mixins/ValidationMixin";
import { nurseryHoursModule } from "@/store/dataModules/nurseryHoursModule";

interface DataType {
  childcareType: string | null;
  firstName: string | null;
  firstNameKana: string | null;
  lastName: string | null;
  lastNameKana: string | null;
  gender: string | null;
  dateOfBirth: string | null;
  optionalChildCode1: string | null;
  optionalChildCode2: string | null;
  admissionDate: string | null;
  graduationDate: string | null;
  moveOrLeave: boolean | null;
  reason: string | null;
  notaBene: string | null;
  hoursPatternId: string | null;

  isCreating: boolean;
  isFormValid: boolean;
}

export default defineComponent({
  mixins: [ValidationMixin],

  computed: {
    classes(): NurseryClassResponse[] {
      return classModule.classes;
    },
    classOptions(): any[] {
      return this.classes.map((c) => {
        return {
          classId: c.classId,
          className: `${c.year}年度 ${c.className}`,
        };
      });
    },
    childTypeOptions() {
      return [
        { value: "normal", label: "一般保育" },
        { value: "temporary", label: "一時保育" },
      ];
    },
    genderOptions() {
      return [
        { value: "male", label: "男性" },
        { value: "female", label: "女性" },
      ];
    },
    patternList: function (): NurseryHoursPatternResponse[] {
      return nurseryHoursModule.patternList;
    },
  },

  data: (): DataType => {
    return {
      childcareType: null,
      firstName: null,
      firstNameKana: null,
      lastName: null,
      lastNameKana: null,
      gender: null,
      dateOfBirth: null,
      optionalChildCode1: null,
      optionalChildCode2: null,
      admissionDate: null,
      graduationDate: null,
      moveOrLeave: null,
      reason: null,
      notaBene: null,
      hoursPatternId: null,

      isCreating: false,
      isFormValid: false,
    };
  },

  methods: {
    async create() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        this.isCreating = true;

        try {
          const created = await childAccountCreateModule
            .createChild({
              nurseryId,
              childcareType: this.childcareType || undefined,
              firstName: this.firstName || undefined,
              firstNameKana: this.firstNameKana || undefined,
              lastName: this.lastName || undefined,
              lastNameKana: this.lastNameKana || undefined,
              gender: this.gender || undefined,
              dateOfBirth: this.dateOfBirth || undefined,
              optionalChildCode1: this.optionalChildCode1 || undefined,
              optionalChildCode2: this.optionalChildCode2 || undefined,
              admissionDate: this.admissionDate || undefined,
              graduationDate: this.graduationDate || undefined,
              moveOrLeave: this.moveOrLeave || false,
              reason: this.reason || undefined,
              notaBene: this.notaBene || undefined,
              hoursPatternId: this.hoursPatternId || undefined,
              allergicFoodIds: [],
            })
            .catch((e) => {
              console.warn(e);
            });
          if (created) {
            this.$router.push(`/children`);
          }
        } catch {
          this.isCreating = false;
        }

        this.isCreating = false;
      }
    },
  },

  async mounted() {
    const nurseryId = LocalDataService.getNurseryId();
    if (nurseryId) {
      await classModule.listClass({
        nurseryId: nurseryId,
      });
      await nurseryHoursModule.listPattern({
        nurseryId,
      });
    }
  },
});
</script>
